export default __webpack_public_path__ + "static/media/44D93429-2F93-49AE-AA4D-0FAF19F304DC.129d0155.jpeg";